<template>
    <div class="container">
         <div class="scroll">
             <scroll v-if="mbActiveTradeList.length" :data="mbActiveTradeList"
                :allLoaded="allLoaded"  @pulldown="loadData" @loadUp="loadup" >
                <div  v-for="(item,index) in mbActiveTradeList" :key="index" >
                    <div class="list_box" @click="toPointOrderDetails(item)">
                        <!-- 已提货已过期  兑换活动  actType  1 为商品 2为券  tradeStatus 5 以上为已收货
                        券状态 0 未使用 1 已使用 2 已过期 3 已锁定
                        -->
                        <img  v-if="item.actType ==1 &&( item.tradeStatus ==5 ||item.tradeStatus ==6)" class="list_box_icon" src="../../assets/images/icon_jifen_tihuo.png" />
                        <img  v-else-if=" item.actType ==2 && (item.status == 2)" class="list_box_icon" src="../../assets/images/icon_jifen_expired.png" />
                        <img  v-else-if="item.actType ==2 && (item.status == 1)" class="list_box_icon" src="../../assets/images/icon_jifen_used.png" />
                        <img class="list_box_left_icon" v-if="item.templateType=='1'" src='../../assets/images/img_mall_zfq.png' />
                        <img class="list_box_left_icon" :src="item.actImgPath" v-else />
                        <div class="list_box_center">
                            <span class="list_box_center_span1">{{item.actName}}</span>
                            <span class="list_box_center_span2">{{item.createTime}}</span>
                        </div>
                        <div class="list_box_right">
                            <span class="list_box_right_span1">{{item.changeVal}}积分</span>
                            <span v-if="item.actType ==1 &&  item.tradeStatus ==0 " class="list_box_right_span3">待支付</span>
                            <span v-if="item.actType ==1 &&  item.tradeStatus ==7 " class="list_box_right_span4">已取消</span>
                            <span v-if="item.actType ==1 &&  (item.tradeStatus ==3 || item.tradeStatus ==4)" class="list_box_right_span3">待提货</span>
                            <span v-if=" item.actType ==2 && item.status==0 && item.link" class="list_box_right_span2">去使用</span>
                        </div>
                    </div>
                </div>
             </scroll>
         </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import {getMbActiveTradeListByUserId} from "../../utils/api";


import Scroll from '../../components/scroll';
export default {
  name: "ExchangeRecords",
  components: {
      Scroll,
  },
  computed: {
    ...mapState({
      common: state => state.common,
    })
  },
  data() {
    return {
      typeList:[1,2,3,4,5,6,7,8,9,10],
      valveList:[],
      allLoaded:true,
      mbActiveTradeList:[],
      pageNo:1,
    }
  },
  created () {
      this.getMbActiveTradeListByUserId();

  },
  methods: {
      getMbActiveTradeListByUserId(){
           var param = {
            "memberCode": this.common.userInfo.memberCode,
            "status": '',
            "pageSize": 10,
            "pageNo": this.pageNo,
           // "marketId": '25',
           // "marketId":this.common.marketInfo.id,
        }
        getMbActiveTradeListByUserId( param).then(res => {
          if (res.res.code === 10000) {
                // var list = res.body.mbActiveList;
                 let  list = res.body.mbActiveTradeList;
                if (this.pageNo === 1) {
                    this.mbActiveTradeList =  list ;
                } else {
                    this.mbActiveTradeList = this.mbActiveTradeList.concat(list )
                }
                if(!list ){
                    this.allLoaded =true
                } else if(list.length%10==0){
                    this.allLoaded =false
                }else{
                    this.allLoaded =true;
                }
          }
        });
      },

      toPointOrderDetails(item){
          this.$router.push(`/PointOrderDetails?id=${item.id}`);
        // this.$router.push({
        //    path:'/PointOrderDetails'
        // })

      },

       loadup () {
        if (this.allLoaded) {
            return;
        }
        this.pageNo++;
        this. getMbActiveTradeListByUserId();
    },
    loadData () {
        this.allLoaded=false;
        this.pageNo = 1;
        this. getMbActiveTradeListByUserId();
    },
  }
}
</script>

<style lang="less" scoped>
@import "../../assets/css/common.less";
.container{
    // width:100%;
    height: 100vh;
    position: relative;
    background:#EEEEEE;
    .flex(column);
    .scroll {
        flex: 1;
        height: 500px;
    }

}

.list_box{
    height: 216px;
    width: 94.6%;
    background-color: white;
    border-radius:8px;
    margin-top: 20px;
    margin-left: 20px;
    display: flex;
    position: relative;
    flex-direction: row;
    .list_box_icon{
        position:absolute;
        top: 48px;
        right: 32px;
        width: 120px;
        height: 120px;
        z-index: 1;

    }

   .list_box_left_icon{
       margin-top: 24px;
       margin-left: 24px;
       margin-right: 24px;
       width:168px;
       height:168px;
       z-index: 10;
   }
   .list_box_center{
       width: 298px;
       display: flex;
       flex-direction: column;
       z-index: 10;
        .list_box_center_span1{
            margin-top: 28px;
            width:298px;
            height:42px;
            font-size:30px;
            font-weight:500;
            color:rgba(51,51,51,1);
            line-height:42px;
            .textOver(298px);
        }
        .list_box_center_span2{
            margin-top: 10px;
            height:34px;
            font-size:24px;
            font-weight:400;
            color:rgba(153,153,153,1);
            line-height:34px;

        }
   }
   .list_box_right{
       width: 168px;
       display: flex;
       align-items: flex-end;
       flex-direction: column;
       z-index: 10;
       .list_box_right_span1{
           margin-top: 28px;
           height:40px;
           font-size:28px;
           font-weight:400;
           color:rgba(51,51,51,1);
           line-height:32px;
       }
       .list_box_right_span2{
            width:128px;
            height:56px;
            margin-top: 64px;
            text-align: center;
            border-radius:8px;
            border:2px solid rgba(255,126,30,1);
            font-size:26px;
            font-weight:400;
            color:rgba(255,126,30,1);
            line-height:56px;
       }
       .list_box_right_span3{
            width:128px;
            height:56px;
            margin-top: 64px;
            text-align: center;
            // border-radius:8px;
            // border:2px solid rgba(255,126,30,1);
            font-size:26px;
            font-weight:400;
            color:rgba(255,126,30,1);
            line-height:56px;
       }
       .list_box_right_span4{
            width:128px;
            height:56px;
            margin-top: 64px;
            text-align: center;
            // border-radius:8px;
            // border:2px solid rgba(255,126,30,1);
            font-size:26px;
            font-weight:400;
            color:rgba(51,51,51,0.7);
            line-height:56px;
       }
   }


}
</style>